import { useEffect } from 'react';
import { useCommandPalette } from './CommandPaletteContext';

function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (target.isContentEditable) return true;
  return false;
}

export function useCommandPaletteHotkey() {
  const { togglePalette } = useCommandPalette();

  useEffect(() => {
    function handler(event: KeyboardEvent) {
      const isK = event.key === 'k' || event.key === 'K';
      const isSlash = event.key === '/';
      const isModifierK = (event.metaKey || event.ctrlKey) && isK;

      if (isModifierK) {
        event.preventDefault();
        togglePalette('cmd_k');
        return;
      }

      if (
        isSlash &&
        !isEditableTarget(event.target) &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.altKey
      ) {
        event.preventDefault();
        togglePalette('slash');
      }
    }

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [togglePalette]);
}
